export const PUBLIC_ROUTES = ["/terms-conditions"];

export const isPublicRoute = (pathname) => PUBLIC_ROUTES.includes(pathname);



// WEBPACK FOOTER //
// ./src/constants/publicURL.js